import FlintLoadingWrapper from "../page_components/common/loading/FlintLoadingWrapper";
import './PreloaderComponent.scss'
import PageTitleHeaderComponent from "../page_components/common/page_ttle/PageTitleHeaderComponent";
import {
    FlintNotificationContextProvider,
    useFlintNotificationContext
} from "../page_components/common/notifications/FlintNotificationContext";
import React, {useEffect, useState} from "react";
import FlintNotification from "../page_components/common/notifications/FlintNotification";

export default function PreloaderComponent(props: PreloaderComponentProps) {
    const {isLoading = true, loadingText = '... loading ...'} = props;
    const [text, setText] = useState<string>(loadingText);

    useEffect(() => {
        if (isLoading)
            setText("... loading ...")
        else {
            setText("...");
        }
    }, [isLoading])
    return (

        <div className="preloader-wrapper">
            {/*<FlintNotificationContextProvider>*/}
                <FlintLoadingWrapper showLoading={isLoading}>
                    <FlintNotification/>
                    {loadingText && <div className={"preloader"} dangerouslySetInnerHTML={{__html: text}}></div>}
                </FlintLoadingWrapper>
            {/*</FlintNotificationContextProvider>*/}
        </div>
    )
}

export interface PreloaderComponentProps {
    isLoading?: boolean;
    loadingText?: string;
}